import { useState } from "react";
import Notify from "devextreme/ui/notify";
//DBTables
import { DBModule } from "../../../types/DBTables";
import { UseFormReturn } from "react-hook-form";

import NumberEditor from "../../Global/Editors/NumberEditor";
import CheckboxEditor from "../../Global/Editors/CheckboxEditor";
import TextEditor from "../../Global/Editors/TextEditor";
import { useGlobalData } from "../../GlobalDataProvider";
import SelectEditor from "../../Global/Editors/SelectEditor";
import { DTOModule } from "../../../types/building";
import { IModuleRound } from "../../../modules/roundHandler";
import { nameof } from "../../Global/Utils";
import { IModuleKylaVattenburet, IModuleVärmeEl } from "../../../types/ModuleDatas";
import { MapTooltip } from "../../../types/globalData";
import BFLNote from "../BFL/BFLNote";

interface IProps {
  module: IModuleRound;
  data: any;
  formHook: UseFormReturn;
}

const RoundKylaVattenburet = ({ module, data, formHook }: IProps) => {
  const globalData = useGlobalData();

  const kylFormerAll = globalData.data ? globalData.data.Kyla.Kylform_Faktor.map((r) => r.Kylform) : [];
  const kylFormer = kylFormerAll.filter((r) => r !== "Intern kylmaskin i ventilationsaggregat");

  return (
    <>
      <div className="row ml-0">
        <div className="col-lg-12 mb-3">
          <SelectEditor
            label="Kylform"
            fieldName={nameof<IModuleKylaVattenburet>("kylform")}
            tooltipId={nameof<MapTooltip>("KylaVattenburet_kylform")}
            formHook={formHook}
            items={kylFormer}
          ></SelectEditor>
        </div>
      </div>
      <BFLNote formHook={formHook} />
    </>
  );
};

export default RoundKylaVattenburet;
